import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import sv from './locales/sv.json';
import da from './locales/da.json';
import es from './locales/es.json';
import no from './locales/no.json';

const resources = {
  en: { translation: en },
  sv: { translation: sv },
  da: { translation: da },
  es: { translation: es },
  no: { translation: no },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'sv',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'yubi_language',
      caches: ['localStorage'],
    },
  });

export default i18n;
